import React, { useEffect, useState } from 'react';
import styles from './ApplicationsPage.module.scss';
import TableTopHeader from '../../Molecules/TableTopHeader/ApplicationsTableTopHeader';
import ApplicantsTable from '../../Molecules/Applications/ApplicantsTable';
import { useFetchApplicationNewsLetter } from '../../../Hooks/Applications';

const NewsLetterApplicationPage = () => {
  const [search, setSearch] = useState();
  const [order, setOrder] = useState(['', 'asc']);
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);

  const {
    data: applicationNewsletterData,
    refetch,
    isLoading,
  } = useFetchApplicationNewsLetter({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
  });
  const applicationNewsLetterTableHeader = [
    {
      name: 'البريد الإلكتروني',
      originalName: 'email',
    },
    {
      name: 'تاريخ الاشتراك',
      originalName: 'subscribedOn',
    },
  ];

  useEffect(() => {
    refetch();
  }, [Page, PageSize, search, order]);
  return (
    <div className={styles['container']}>
      <div className={styles['search-container']}>
        <div className={styles['table-container']}>
          <TableTopHeader
            search={search}
            setSearch={setSearch}
            refetch={refetch}
            data={applicationNewsletterData?.data}
            mode="newsletterSubscription"
            tableHeader={applicationNewsLetterTableHeader}
            title="Newsletter Subscription Table"
          />
          <ApplicantsTable
            data={applicationNewsletterData?.data}
            page={Page}
            setPage={setPage}
            pageSize={PageSize}
            order={order}
            refetch={refetch}
            tableHeader={applicationNewsLetterTableHeader}
            mode="newsletterSubscription"
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default NewsLetterApplicationPage;
